<template>
	<div class="offical-container"
		@click="$router.push({path: '/work-details',query: {id:data.id,userId: data.user_id,type: routerType}})">
		<img class="bestIcon" src="../assets/Home/best.png" v-if="data.shuxing && data.shuxing == '精品图'" />
		<img class="soldOutIcon" src="../assets/BuyNow/iconJ.png" v-if="data.status == 3 && isShow" />
		<div class="likeNum">
			<img class="likeNumIcon" src="../assets/WorkDetails/iconL.png" />
			<span>{{data.zan_count}}</span>
		</div>
		<img class="likeIcon" :src="data.img" />
		<div class="likeTitle ellipsis-1">{{data.title}}</div>
		<div class="likeDesc ellipsis-2">
			{{data.content}}
		</div>
		<div class="tips">
			<div class="tip ellipsis-1">
				{{data.cid}}
			</div>
			<div class="tip ellipsis-1" v-for="(item,index) in data.yongtu.slice(0,1)" :key="index">
				{{item}}
			</div>
		</div>
		<div class="buyNow" v-if="showBuy">
			￥{{data.price ? data.price : '0'}} 立即购买
		</div>
	</div>
</template>
<script>
	export default {
		name: 'OfficalItem',
		props: {
			data: {
				type: Object,
				default: () => {}
			},
			showBuy: {
				type: Boolean,
				default: false
			},
			isShow: {
				type: Boolean,
				default: false
			},
			routerType: {
				type: Number,
				default: 1
			},
		},
		data() {
			return {

			}
		}
	}
</script>

<style lang="scss" scoped>
	@media (max-width: 480px) {
		.offical-container {
			margin-top: .64rem;
			display: flex;
			flex-direction: column;
			margin-right: .48rem;
			position: relative;
			cursor: pointer;

			.bestIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: 1.34rem;
				height: .1.34rem;
			}

			.soldOutIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: 5.64rem;
				height: 7.44rem;
				z-index: 1;
			}

			.likeNum {
				position: absolute;
				top: .32rem;
				right: .32rem;
				height: .48rem;
				display: flex;
				align-items: center;
				padding: 0 .2rem;
				background: rgba(255, 255, 255, .9);
				box-shadow: 0px 2px 15px 0px rgba(176, 176, 176, 0.6);
				border-radius: .24rem;
				font-weight: 500;
				font-size: .28rem;
				color: #333333;

				.likeNumIcon {
					margin-right: .08rem;
					width: .3rem;
					height: .28rem;
				}

				span {
					margin-top: .02rem;
				}
			}

			.likeIcon {
				width: 5.64rem;
				height: 7.44rem;
				border-radius: .2rem;
				object-fit: cover;
				overflow: hidden;
			}

			.likeTitle {
				width: 5.64rem;
				margin-top: .64rem;
				font-weight: 600;
				font-size: .48rem;
				color: #000000;
				line-height: .48rem;
			}

			.likeDesc {
				height: .8rem;
				width: 5.64rem;
				margin-top: .2rem;
				font-weight: 400;
				font-size: .28rem;
				color: #333333;
				line-height: .4rem;
			}

			.tips {
				margin-top: .32rem;
				width: 5.64rem;
				display: flex;
				align-items: center;

				.tip {
					height: .52rem;
					margin-right: .24rem;
					padding: 0 .16rem;
					font-weight: 400;
					font-size: .24rem;
					color: #A88653;
					line-height: .52rem;
					border-radius: .26rem;
					border: .02rem solid #A88653;
				}
			}

			.buyNow {
				margin: .48rem auto 0;
				width: 5.2rem;
				height: 1.04rem;
				background: #E29358;
				border-radius: .12rem;
				font-weight: 500;
				font-size: .3rem;
				color: #252525;
				line-height: 1.04rem;
				text-align: center;
			}
		}
	}

	@media (min-width: 481px) {
		.offical-container {
			margin-top: .32rem;
			display: flex;
			flex-direction: column;
			margin-right: .24rem;
			position: relative;
			cursor: pointer;

			.bestIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: .67rem;
				height: .67rem;
			}

			.soldOutIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: 2.82rem;
				height: 3.72rem;
				z-index: 1;
			}

			.likeNum {
				position: absolute;
				top: .16rem;
				right: .16rem;
				height: .24rem;
				display: flex;
				align-items: center;
				padding: 0 .1rem;
				background: rgba(255, 255, 255, .9);
				box-shadow: 0px 2px 15px 0px rgba(176, 176, 176, 0.6);
				border-radius: .12rem;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;

				.likeNumIcon {
					margin-right: .02rem;
					width: .15rem;
					height: .14rem;
				}

				span {
					margin-top: .02rem;
				}
			}

			.likeIcon {
				width: 2.82rem;
				height: 3.72rem;
				border-radius: .1rem;
				object-fit: cover;
				overflow: hidden;
			}

			.likeTitle {
				width: 2.82rem;
				margin-top: .32rem;
				font-weight: 600;
				font-size: .24rem;
				color: #000000;
				line-height: .32rem;
			}

			.likeDesc {
				height: .4rem;
				width: 2.82rem;
				margin-top: .1rem;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;
			}

			.tips {
				margin-top: .16rem;
				width: 2.82rem;
				display: flex;
				align-items: center;

				.tip {
					height: .26rem;
					margin-right: .12rem;
					padding: 0 .08rem;
					font-weight: 400;
					font-size: .12rem;
					color: #A88653;
					line-height: .24rem;
					border-radius: .13rem;
					border: .01rem solid #A88653;
				}
			}

			.buyNow {
				margin: .24rem auto 0;
				width: 2.60rem;
				height: .52rem;
				background: #E29358;
				border-radius: .06rem;
				font-weight: 500;
				font-size: .15rem;
				color: #252525;
				line-height: .52rem;
				text-align: center;
			}
		}
	}
</style>